import { AgenturNameCell } from 'app/components/shared/AgenturName.cell';
import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { WkzgKofferVM } from 'app/stores/ui/agt.wkzgkoffer.ui.store';
import { WerkzeugProgress } from './WerkzeugkofferBakListe';
import { countArray } from 'app/utils';
import colors from 'assets/scss/colors.module.scss';


interface IWerkzeugkofferOverviewListe {
	year: number;
}

export const WerkzeugkofferOverviewListe = observer((props: IWerkzeugkofferOverviewListe) => {
	const { berichteUiiStore, agtWkzkofferUiStore, agenturListUiStore } = useStore();
	const history = useHistory();
	const [hasItems, setHasItems] = useState(false);

	const tm = useMemo(() => {
		const tm = new TableModel<WkzgKofferVM, number>();
		const cols: ITableColumn<WkzgKofferVM, number>[] = [];

		cols.push({
			label: 'Agentur',
			path: 'agt.name',
			sortBy: 'agt.name',
			render: AgenturNameCell,
		});
		cols.push({
			label: 'FZW',
			path: 'fzw.sumKontingent',
			render(row) {
				if (!row.data.fzw.hasWkzg) return <>Keine Nutzung</>;
				return <>{row.data.fzw.sumKontingent}</>;
			},
		});
		cols.push({
			label: 'BAK',
			path: 'bak.bakAvg',
			render(row) {
				if (!row.data.bak.hasWkzg) return <>Keine Nutzung</>;
				return <WerkzeugProgress numLeft={row.data.bak.sumRest} total={row.data.bak.sumKontingent} />;
			},
		});
		if (props.year === 2026) {
			cols.push({
				label: 'BAK-Verzicht',
				path: 'bak.restBakVerz',
				render(row) {
					return <WerkzeugProgress numLeft={row.data.bak.restBakVerz} total={row.data.bak.bakVerzicht} color={colors.turquoise} />;
				},
				agg: {
					aggType: AggregrationType.sum,
					render(tm) {
						const num = countArray(tm.data.map((vm) => vm.bak.restBakVerz));
						const total = countArray(tm.data.map((vm) => vm.bak.bakVerzicht));
						return <WerkzeugProgress numLeft={num} total={total} color={colors.turquoise} />;
					},
				},
			});
		}
		tm.sortBy = 'agt.name';
		tm.setCols(cols);

		tm.idProperty = 'agtId';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		agtWkzkofferUiStore.load().then(() => {
			let items = agtWkzkofferUiStore.items;
			items = items.filter(x => x.year === props.year);
			if (berichteUiiStore.selectedAgt) {
				const agtId = berichteUiiStore.selectedAgt.agtId;
				items = items.filter((i) => i.agt.agtId === agtId);
			} else {
				items = agenturListUiStore.applyFilterOnAgt(items) as WkzgKofferVM[];
			}
			setHasItems(items.length > 0);
			tm.setRowData(items);
			tm.sort();
		});
	}, [tm, berichteUiiStore.selectedAgt, agenturListUiStore.filterHasChanged, agenturListUiStore, agtWkzkofferUiStore.items, agtWkzkofferUiStore]);

	return (
		<>
			<div className="table-container pad-bottom-3rem">
				{!hasItems ? (
					<div className="pad-1rem">Keine Werkzeugkoffer Teilnahme</div>
				) : (
					<>
						<Table stickyHeader={true} tm={tm}></Table>
					</>
				)}
			</div>
		</>
	);
});
